/* global axios */
/* Customização: API client para silenciar conversas */
import ApiClient from './ApiClient';

class ConversationMuteAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  mute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/mute`);
  }

  unmute(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/mute`);
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/mute`);
  }
}

export default new ConversationMuteAPI();
